import { Col, Row } from 'antd';
import { ReactNode } from 'react';
import { spacingLg, spacingMd, spacingSm } from 'theme/sizes';
import StatusIcon, { StatusIconProps } from '../status-icon/StatusIcon';
import { Gap, Layout, StyledHeaderRow, StyledRightColumn, StyledSection, StyledTitle } from './styles';

const GAP_MAP: Record<Gap, number> = {
    small: spacingSm,
    medium: spacingMd,
    large: spacingLg,
};

type Props = {
    iconProps: StatusIconProps;
    title?: string;
    subtitle?: string;
    gap?: Gap; // Spacing between the icon and the rest of the content
    layout?: Layout; // Whether the content should be rendered below the title or start from under the icon
    bordered?: boolean;
    children?: ReactNode;
    headerActions?: ReactNode;
};

const CardWithIcon = ({
    iconProps,
    title,
    subtitle,
    headerActions,
    layout = 'horizontal',
    gap = 'medium',
    bordered = true,
    children,
}: Props) => {
    const gapPx = GAP_MAP[gap];

    if (layout === 'vertical') {
        return (
            <StyledSection $bordered={bordered} $layout={layout} $gapPx={gapPx}>
                <StyledHeaderRow $layout="vertical" $gapPx={gapPx}>
                    <StatusIcon {...iconProps} />
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        {title && <StyledTitle>{title}</StyledTitle>}
                        {headerActions}
                    </div>
                </StyledHeaderRow>

                {children}
            </StyledSection>
        );
    }

    return (
        <StyledSection $bordered={bordered} $layout={layout} $gapPx={gapPx}>
            <StyledHeaderRow $layout="horizontal" $gapPx={gapPx}>
                <StatusIcon {...iconProps} />
                <StyledRightColumn>
                    <Row justify="space-between">
                        {title && (
                            <Col>
                                <StyledTitle>{title}</StyledTitle>
                                {subtitle}
                            </Col>
                        )}
                        {headerActions && <Col>{headerActions}</Col>}
                    </Row>
                    {children}
                </StyledRightColumn>
            </StyledHeaderRow>
        </StyledSection>
    );
};

export default CardWithIcon;
